export class CustomSelectModel {
  private query: string = '';
  public value: string = '';
  public filteredGroups: CustomSelectGroup[] = [];

  constructor(
    public groups: CustomSelectGroup[],
    public placeholder: string,
    public hasSearch: boolean = false,
    public groupsVisible: boolean = false,
    public isMultiSelect: boolean = false,
    public updateMenuWithSelected: boolean = false
  ) {
    this.updateFilteredOptions(this.query);
  }

  public updateFilteredOptions(query: string) {
    this.query = query;

    this.filteredGroups = [];
    this.groups.forEach(group => {
      const options = group.options.filter(option =>
        option.label.toLowerCase().includes(query.toLowerCase())
      );
      if (options.length) {
        this.filteredGroups.push(new CustomSelectGroup(options, group.name));
      }
    });
  }
}

export class CustomSelectGroup {
  constructor(public options: CustomSelectOption[], public name: string = '') {}

  get selectAllText() {
    return this.options.filter(option => !option.isSelected).length > 0
      ? 'Select all'
      : 'Unselect all';
  }
}

export class CustomSelectOption {
  constructor(
    public uuid: string,
    public label: string,
    public isSelected: boolean = false,
    public topic: string = label
  ) {}
}
